import { queryOptions } from "@tanstack/react-query";
import { Capacitor } from "@/lib/capacitor";
import { PushNotifications } from "@/lib/capacitor/push-notifications";

export const queryOptions_pushNotificationsPermissions = () =>
  queryOptions({
    queryKey: ["@capacitor/push-notifications", "check-permissions"] as const,
    queryFn: async () => {
      if (Capacitor.Platform === "web") {
        return "unavailable";
      }

      const permissions = await PushNotifications.checkPermissions();

      return permissions ?? "unknown";
    },
    // Refresh permission state when user returns to app (they might have changed it in OS settings)
    staleTime: 30 * 1000, // 30 seconds - balance between accuracy and performance
  });
